import { useToastService } from "@@common";
import { ContentCopy } from "@mui/icons-material";
import { IconButton, SxProps, Theme } from "@mui/material";
import React from "react";

interface CopyToClipboardButtonProps {
  value: string;
  size?: "small" | "medium" | "large";
  title?: string;
  edge?: "start" | "end" | false;
  iconSize?: number;
  sx?: SxProps<Theme>;
}

export default function CopyToClipboardButton({
  value,
  size = "small",
  title = "Copy value to clipboard",
  edge = "end",
  iconSize = 18,
  sx,
}: CopyToClipboardButtonProps) {
  const toastService = useToastService();

  const handleCopyToClipboard = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value);
    toastService.success("Copied to clipboard");
  };

  return (
    <IconButton size={size} onClick={handleCopyToClipboard} title={title} edge={edge} sx={sx}>
      <ContentCopy sx={{ fontSize: iconSize }} />
    </IconButton>
  );
}
